import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const withoutKit = ['Fichas en papel', 'Horas perdidas', 'Sin seguimiento objetivo', 'Imagen improvisada', 'Riesgo legal', 'Sin gráficos para mostrar al paciente'];
const withKit = ['Historias clínicas digitales', 'Planes listos en minutos', 'Evolución objetiva y visual', 'Imagen profesional', 'Respaldo legal', 'Gráficos automáticos de progreso'];
export function Comparison() {
  return <section className="py-20 bg-gray-50" data-id="element-50">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-53">
            Tu consultorio hoy vs. tu consultorio con el NutriPro Kit
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-54">
          {/* SIN EL KIT */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm" data-id="element-55">
            <h3 className="text-xl font-bold text-gray-500 mb-6 text-center uppercase tracking-wider" data-id="element-56">
              SIN el Kit
            </h3>
            <ul className="space-y-4" data-id="element-57">
              {withoutKit.map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-600" data-id="element-58">
                  <div className="bg-red-100 p-1 rounded-full flex-shrink-0" data-id="element-59">
                    <X size={16} className="text-red-500" data-id="element-60" />
                  </div>
                  <span className="font-medium" data-id="element-61">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* CON EL KIT */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-nutri-dark rounded-2xl p-8 border border-nutri-medium shadow-xl relative overflow-hidden" data-id="element-62">
            <div className="absolute top-0 right-0 w-32 h-32 bg-nutri-medium rounded-full blur-3xl opacity-20 -mr-10 -mt-10" data-id="element-63"></div>
            <h3 className="text-xl font-bold text-nutri-mint mb-6 text-center uppercase tracking-wider relative z-10" data-id="element-64">
              CON el Kit
            </h3>
            <ul className="space-y-4 relative z-10" data-id="element-65">
              {withKit.map((item, i) => <li key={i} className="flex items-center gap-3 text-white" data-id="element-66">
                  <div className="bg-nutri-mint p-1 rounded-full flex-shrink-0" data-id="element-67">
                    <Check size={16} className="text-nutri-dark" data-id="element-68" />
                  </div>
                  <span className="font-medium" data-id="element-69">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}